import { deepMerge } from '@src/utilities';
import { baseTheme } from './baseTheme';

export const customTheme = deepMerge({}, baseTheme, {
    colors: {
        primary: {
            main: {
                filled: '#233AC6',
                hover: '#3d4bc2',
            },
        },
    },
});
